var Cocoen = require("cocoen");
var scrollMonitor = require("scrollmonitor");
var anime = require("animejs");

var Gallery5 = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

Gallery5.prototype.init = function(){

  var self = this;
  
  new Cocoen(this.options.$el.find(".cocoen")[0]);

  this.$handle = this.options.$el.find(".cocoen-drag");
  this.$mask = this.options.$el.find(".cocoen div");
  this.$handle.css({left: "80%"});
  this.$mask.css({width: "80%"});

  var topOffset = -600;
  if(window.Breakpoint.value == "xsmall" || window.Breakpoint.value == "small"){
    topOffset = -200;
  }

  var elementWatcher = scrollMonitor.create(this.options.$el[0], {top: topOffset});

  elementWatcher.enterViewport(function() {

    if(! self.hasRun){
      self.runAnimation();
      self.hasRun = true;
    }

  });

};

/**
 * Running the animation
 */
Gallery5.prototype.runAnimation = function(){

  var self = this;

  anime({
    targets: self.$handle[0],
    keyframes: [
      {left: "0%"},
      {left: "20%"}
    ],
    easing: window.easings.feebles1,
    duration: 2500
  });

  anime({
    targets: self.$mask[0],
    keyframes: [
      {width: "0%"},
      {width: "20%"}
    ],
    easing: window.easings.feebles1,
    duration: 2500
  });

}

module.exports = Gallery5;
